import { FragmentLoader } from "@sendgrid/ui-components/fragment-loader";
import Styles from "./Loading.module.scss";

export const Loading = () => (
  <div className={Styles["full-page-load"]}>
    <FragmentLoader centered large />
  </div>
);
